import { render, staticRenderFns } from "./Debt.vue?vue&type=template&id=06af33aa&scoped=true"
import script from "./Debt.vue?vue&type=script&lang=js"
export * from "./Debt.vue?vue&type=script&lang=js"
import style0 from "./Debt.vue?vue&type=style&index=0&id=06af33aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06af33aa",
  null
  
)

export default component.exports